export const getLoyaltyMembershipInput = () => {
  if (typeof window !== 'undefined') {
    return window?.THDCustomer?.default?.membershipInformation;
  }

  return null;
};

export const getCustomerType = () => {
  if (typeof window !== 'undefined') {
    return window?.THDCustomer?.default?.customerType;
  }

  return 'B2C';
};

export const getUserLoggedIn = () => {
  if (typeof window !== 'undefined') {
    return window?.THDCustomer?.default?.isLoggedIn;
  }

  return false;
};

export const getB2BUser = () => {
  if (typeof window !== 'undefined') {
    return window?.THDCustomer?.default?.isB2BCustomer;
  }

  return false;
};

export const getSVOCID = () => {
  if (typeof window !== 'undefined') {
    return window?.THDCustomer?.default?.svocID;
  }

  return '';
};
